import useActivityFilterStore from '@app.feature/activityFilter/store/storeActivityFilter'
import { ActivityTypeID } from 'constants/enums'

export const useActivityFilterMid = () => {
  const activityType = useActivityFilterStore((state) => state.activityType)
  const activityTypeIsRecruit =
    activityType === ActivityTypeID.INTERN ||
    activityType === ActivityTypeID.RECRUIT

  return {
    activityTypeIsRecruit,
  }
}
